// API 基础配置
// 使用相对路径，通过 Nginx 代理，自动适配 HTTP/HTTPS
// 设置为空字符串，这样 /api/xxx 会使用当前页面的协议（HTTPS）
export const API_BASE_URL = ''
// MinIO 浏览器上传 HTTPS 入口（不含桶路径），视频参考和资产上传共用。
// 上传完成后的展示链接仍使用后端 HTTPS domain；留空则使用后端 public-endpoint。
export const MINIO_UPLOAD_BASE_URL = 'https://www.yuyuankj.cn'

// 如果需要直接访问后端（开发环境），可以取消注释下面这行
// export const API_BASE_URL = 'http://119.91.46.75:6199'
// export const API_BASE_URL = 'http://localhost:6199'
// Token 存储 key
export const TOKEN_KEY = 'token'

// 用户信息存储 key
export const USER_INFO_KEY = 'userInfo'

// 用户权限存储 key
export const PERMISSIONS_KEY = 'permissions'

// 选中的工作空间ID存储 key
export const SELECTED_WORKSPACE_ID_KEY = 'selectedWorkspaceId'
// 存储用户选择的剧本对象（JSON 字符串）
export const SELECTED_SCRIPT_KEY = 'selectedScript'

// 图片生成页面配置存储 key
export const IMAGE_GEN_CONFIG_KEY = 'imageGenConfig'

// 视频生成页面配置存储 key
export const VIDEO_GEN_CONFIG_KEY = 'videoGenConfig'

// ==================== 七牛云配置 ====================
/**
 * 七牛云上传API地址
 * 华东: https://upload.qiniup.com
 * 华北: https://upload-z1.qiniup.com
 * 华南: https://upload-z2.qiniup.com
 * 北美: https://upload-na0.qiniup.com
 *
 * 注意：此配置需与后端七牛云存储区域保持一致
 * 后端配置：file.upload.qiniu.region
 */
export const QINIU_UPLOAD_API_URL = 'https://upload-z2.qiniup.com'
export const QINIU_UPLOAD_API_URLS = [
  QINIU_UPLOAD_API_URL,
  'https://up-z2.qiniup.com'
]
